import * as React from "react";
import { Box, Paper, Divider } from "@mui/material";

export default function HelpPanel({ title, children }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        border: "1px solid #BBDEFB",
        width: "100%",
        height: "100%",       
        display: "flex",
        flexDirection: "column",
          backgroundColor: "#BBDEFB",
      }}
    >
      <Box
        sx={{
          py: 1,
          px: 2,
          textAlign: "center",
          fontWeight: 600,
          fontSize: ".95rem",
        }}
      >
        {title}
      </Box>

      <Divider sx={{ borderColor: "white" }} />

      <Box sx={{ flexGrow: 1 }}>
        {children}
      </Box>
    </Paper>
  );
}
